module.exports = __webpack_public_path__ + "img/icon_utill_jp.f841434f.svg";